import { render, staticRenderFns } from "./Outgoings.vue?vue&type=template&id=963e12fc"
import script from "./Outgoings.vue?vue&type=script&lang=js"
export * from "./Outgoings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports